import React, { useEffect, useState } from "react";
import {
  Link,
  Navigate,
  NavLink,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
// import { jobCandidates } from "../../../../common/data/appsJobs";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { jobCandidates } from "../../../common/data/appsJobs";
import AddInstitute from "../Component/AddInstitute";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const AffiliatedInstitutes = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await UniversityService.getList();
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await UniversityService.delete(selectedDeleteItem.id);
        await fetchData();
        toast.success("Institute deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Institute"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // Adjust per row/card layout

  const filteredInstitutes = institutedata.filter((item) => {
    const term = searchTerm.toLowerCase();
    const rankingStr = item.ranking ? item.ranking.toString() : "";

    return (
      item.name.toLowerCase().includes(term) ||
      (item.destinationCountryName &&
        item.destinationCountryName.toLowerCase().includes(term)) ||
      rankingStr.includes(term) ||
      (item.isPartner &&
        (item.isPartner ? "partner" : "not partner").includes(term))
    );
  });

  const totalPages = Math.ceil(filteredInstitutes.length / itemsPerPage);
  const paginatedInstitutes = filteredInstitutes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // const handleDeleteClick = async (key) => {
  //   await UniversityService.delete(key);
  //   fetchData(); // reload data instead of window.location.reload()
  // };
  const pageWindow = 5;

  const getVisiblePages = () => {
    const start = Math.floor((currentPage - 1) / pageWindow) * pageWindow + 1;
    const end = Math.min(start + pageWindow - 1, totalPages);

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  document.title = "Affiliated Institute | Kangaroo Foundation";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="container-fluid">
          <BreadCrumb
            title="Institute List"
            pageTitle="Locatio & Affiliation"
            // breadcrumbItems={[{ title: "Back to List", link: "/institute" }]}
          />

          <Row className="g-4 mb-4">
            <Col className="col-sm-auto">
              <button
                className="btn btn-success"
                color="secondary"
                onClick={() => navigate("/affiliateinstitute-form")}
              >
                <div>
                  <i className="ri-add-line align-bottom me-1"></i> Add Insitute
                </div>
              </button>
            </Col>
            <Col className="col-sm">
              <div className="d-md-flex justify-content-sm-end gap-2">
                <div className="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                  <Input
                    type="text"
                    className="form-control"
                    id="searchJob"
                    autoComplete="off"
                    placeholder="Search by name, destination, ranking, partner"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="g-4 mb-4">
            {paginatedInstitutes?.map((item, key) => (
              <Col xxl={4} md={6} key={item.id}>
                <Card className="border-0 shadow-sm h-100 overflow-hidden">
                  <CardBody className="p-4 pb-2">
                    <div className="d-flex flex-column h-100 ">
                      {/* Header Section with Logo and Name */}
                      <Col className="d-flex align-items-start ">
                        <div className="flex-shrink-0 position-relative">
                          {item.logoMedia?.url ? (
                            <div
                              className="avatar-lg rounded shadow-sm position-relative overflow-hidden border"
                              style={{ width: "80px", height: "80px" }}
                            >
                              <img
                                src={`${imageBaseApi}${item.logoMedia.url}`}
                                alt={item.name}
                                className="img-fluid w-100 h-100 rounded"
                                style={{ objectFit: "contain" }}
                              />
                            </div>
                          ) : (
                            <div className="avatar-lg rounded bg-light border d-flex align-items-center justify-content-center shadow-sm">
                              <i className="ri-building-line text-primary fs-1"></i>
                            </div>
                          )}
                        </div>

                        <div className="flex-grow-1 ms-4 overflow-hidden ">
                          <Link
                            to={`/institute-detail/${item.id}`}
                            className="text-decoration-none"
                          >
                            <h5 className="fs-16 mb-1 text-dark fw-semibold d-flex align-items-center">
                              <span className="text-truncate me-2">
                                {item.name}
                              </span>
                              <i className="ri-external-link-line text-muted fs-6 flex-shrink-0"></i>
                            </h5>
                          </Link>
                          <p className="text-muted mb-2 d-flex align-items-center small text-truncate">
                            <i className="ri-map-pin-line me-1 text-primary"></i>
                            <span>{item.city}</span>
                          </p>
                          <div className="d-flex flex-wrap gap-2 mb-3">
                            {item.ranking && (
                              <Badge
                                color="light"
                                className="text-dark border d-inline-flex align-items-center px-2 py-1 fw-medium"
                              >
                                <i className="ri-trophy-line me-1 text-warning"></i>
                                Rank {item.ranking}
                              </Badge>
                            )}
                            {item.isPartner && (
                              <Badge
                                color="primary"
                                className="d-inline-flex align-items-center px-2 py-1 fw-medium"
                              >
                                <i className="ri-shield-star-line me-1"></i>
                                Partner
                              </Badge>
                            )}
                            {item.isActive ? (
                              <Badge
                                color="success"
                                className="d-inline-flex align-items-center px-2 py-1 fw-medium"
                              >
                                <i className="ri-checkbox-circle-line me-1"></i>
                                Active
                              </Badge>
                            ) : (
                              <Badge
                                color="danger"
                                className="d-inline-flex align-items-center px-2 py-1 fw-medium"
                              >
                                <i className="ri-close-circle-line me-1"></i>
                                Inactive
                              </Badge>
                            )}
                          </div>
                        </div>
                      </Col>

                      {/* Badges Section */}

                      {/* Details Section */}
                      <div className="border rounded p-2 bg-light mb-1">
                        <div className="d-flex align-items-start">
                          <div className="flex-shrink-0 me-2">
                            <div className="avatar-sm rounded bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
                              <i className="ri-global-line text-primary fs-5"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <p className="text-muted mb-0 small fw-medium">
                              Destination
                            </p>
                            <h6 className="mb-0 fs-14 fw-semibold text-dark">
                              {item.destinationCountryName}
                            </h6>
                          </div>
                        </div>

                        {item.description && (
                          <div className="mt-2">
                            <div className="d-flex align-items-start text-muted small">
                              <i className="ri-information-line text-primary me-2 flex-shrink-0 mt-1 fs-6"></i>
                              <span className="lh-base text-truncate">
                                {item.description}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </CardBody>

                  {/* Card Footer */}
                  <div className="card-footer bg-light border-top d-flex justify-content-between align-items-center py-2 px-4">
                    <Link
                      to={`/institute-detail/${item.id}`}
                      className="card-link link-secondary text-decoration-none fw-semibold d-flex align-items-center small"
                    >
                      View Details
                      <i className="ri-arrow-right-s-line ms-1 align-middle lh-1 fs-5"></i>
                    </Link>

                    <div className="d-flex gap-2">
                      <Button
                        color="warning"
                        className="btn-soft-warning btn-sm d-inline-flex align-items-center justify-content-center p-2"
                        size="sm"
                        onClick={() =>
                          navigate(`/affiliateinstitute-form/update/${item.id}`)
                        }
                      >
                        <i className="ri-edit-line fs-6" />
                      </Button>
                      <Button
                        color="danger"
                        className="btn-soft-danger btn-sm d-inline-flex align-items-center justify-content-center p-2"
                        size="sm"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line fs-6" />
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {totalPages > 1 && (
            <Row className="g-0 justify-content-end mb-4 sticky-bottom ">
              <Col sm={6}>
                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                  {/* Previous */}
                  <button
                    className="page-link"
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  {/* Page Numbers */}
                  {getVisiblePages().map((page) => (
                    <button
                      key={page}
                      className={`page-link ${
                        currentPage === page ? "active" : ""
                      }`}
                      onClick={() => goToPage(page)}
                    >
                      {page}
                    </button>
                  ))}

                  {/* Next */}
                  <button
                    className="page-link"
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </Col>
            </Row>
          )}
        </Container>
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </div>
    </React.Fragment>
  );
};

export default AffiliatedInstitutes;
